import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconComponent } from './icon/icon.component';
import { InputSearchComponent } from './input-search/input-search.component';
import { LoaderComponent } from './loader/loader.component';
import { CrmAlertComponent } from './crm-alert/crm-alert.component';
import { EditEmailComponent } from '../../modules/manage/components/acl-page/users/edit-email/edit-email.component';
import {
  OrderByPipe,
  PresetPipe,
  CurrencyPipe,
  ReportClientUserOtherPipe,
  HistoryFieldNamePipe,
  MinusSignToParensInt,
  MinusSignToParens,
  UseHttpImageSourcePipe
} from '../../pipes';
import { InputDataComponent } from './input-data/input-data.component';
import { SliderComponent } from './slider/slider.component';
import { NgxMaskModule } from 'ngx-mask';
import { AvatarModule } from 'ngx-avatar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TagComponent } from './tag/tag.component';
import { TagSearchComponent } from './tag-search/tag-search.component';
import { Ng5SliderModule } from 'ng5-slider';
import { FiltersComponent } from './filters/filters.component';
import { AssigneeProfileInfoComponent } from '../pages/dashboard/components/assignee-info/assignee-profile-info.component';
import { AssigneeInfoContentComponent } from '../pages/dashboard/components/assignee-info/assignee-content/assignee-content.component';
import { CommaDirective, NumberDirective, SpecialCharacterDirective } from '../../directives';
import { NumberInputComponent } from '../fields/number-input/number-input.component';
import { CustomPreviewComponent } from './custom-preview/custom-preview.component';
import { ImageContentComponent } from './custom-preview/image-content/image-content.component';
import { AngularDraggableModule } from 'angular2-draggable';
import { FilePickerComponent, ProfileInfoComponent, WatchComponent } from '../pages/report/components';
import { NgxUploaderModule } from 'ngx-uploader';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AskComponent, SourceComponent } from '../../modules/bvq/components';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { InputLabelComponent } from './input-label/input-label.component';
import { CustomChartComponent } from './custom-chart/custom-chart.component';
import { MultiSelectComponent } from './multi-select-input/multi-select.component';
import { SpaceSeparatedInputComponent } from './space-separated-input/space-separated-input.component';
import { MultiInputSearchComponent } from './multi-input-search/multi-input-search.component';
import { DsGeneralComponent } from 'src/app/modules/bvq/components/blocks/generic/ds-record-detail/ds-general/ds-general.component';
import { DsRecordListComponent } from 'src/app/modules/bvq/components/blocks/generic/ds-record-list/ds-record-list.component';
import { BzRecordListComponent } from 'src/app/modules/bvq/components/blocks/generic/bz-record-list/bz-record-list.component';
import { BzGeneralComponent } from 'src/app/modules/bvq/components/blocks/generic/bz-record-detail/bz-general/bz-general.component';
import { ConfirmationDialogComponent, CustomAvatarComponent } from '.';
import { ExcelCellComponent } from './excel-cell/excel-cell.component';
import { SelectInputComponent } from './select-input/select-input.component';
import { CommaPipe } from '../pipes/comma.pipe';

@NgModule({
  declarations: [
    IconComponent, InputSearchComponent, LoaderComponent, CrmAlertComponent,MultiSelectComponent,SpaceSeparatedInputComponent,MultiInputSearchComponent,
    EditEmailComponent, InputDataComponent, TagComponent, TagSearchComponent,
    SliderComponent, FiltersComponent, AssigneeProfileInfoComponent, AssigneeInfoContentComponent,
    NumberInputComponent, TagSearchComponent, CustomPreviewComponent, ImageContentComponent,
    WatchComponent, FilePickerComponent, ProfileInfoComponent, ToggleButtonComponent, InputLabelComponent,
    CustomChartComponent, ConfirmationDialogComponent, CustomAvatarComponent,

    // Pipes
    OrderByPipe, PresetPipe, CurrencyPipe, ReportClientUserOtherPipe, HistoryFieldNamePipe,
    MinusSignToParensInt, MinusSignToParens, UseHttpImageSourcePipe, CommaPipe,

    // Directives
    SpecialCharacterDirective, NumberDirective, CommaDirective,

    //BVQ
    AskComponent, SourceComponent,

    //Database
    DsGeneralComponent, DsRecordListComponent, BzRecordListComponent, BzGeneralComponent, ExcelCellComponent, SelectInputComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    PaginationModule.forRoot(),
    Ng5SliderModule,
    BsDropdownModule.forRoot(),
    AvatarModule,
    AngularDraggableModule,
    NgxUploaderModule,
    PopoverModule.forRoot(),
    TooltipModule.forRoot()
  ],
  exports:[
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule,
    BsDropdownModule,
    PaginationModule,
    AvatarModule,
    AngularDraggableModule,
    NgxUploaderModule,
    PopoverModule,
    TooltipModule,

    IconComponent, InputSearchComponent, LoaderComponent, CrmAlertComponent,MultiSelectComponent,SpaceSeparatedInputComponent,MultiInputSearchComponent,
    EditEmailComponent, InputDataComponent, TagComponent, TagSearchComponent,
    SliderComponent, FiltersComponent, AssigneeProfileInfoComponent,
    AssigneeInfoContentComponent, NumberInputComponent, CustomPreviewComponent, ImageContentComponent,
    WatchComponent, FilePickerComponent, ProfileInfoComponent, ToggleButtonComponent, InputLabelComponent,
    CustomChartComponent, ConfirmationDialogComponent, ExcelCellComponent,CustomAvatarComponent,

    // Directives
    SpecialCharacterDirective, NumberDirective, CommaDirective,

    // Pipes
    OrderByPipe, PresetPipe, CurrencyPipe, ReportClientUserOtherPipe, HistoryFieldNamePipe,
    MinusSignToParensInt, MinusSignToParens, UseHttpImageSourcePipe, CommaPipe,

    //BVQ
    SourceComponent, AskComponent,

    //Database
    DsGeneralComponent, DsRecordListComponent, BzRecordListComponent, BzGeneralComponent
  ],
  providers:[
    CommaPipe
  ]
})
export class CoreModule { }
